import(/* webpackMode: "eager" */ "/builds/JohnLewisPartnership/digital/services/money-web/money-web-ui/node_modules/@JohnLewisPartnership/jlfs-ui-library/dist/styles/globals.scss");
;
import(/* webpackMode: "eager" */ "/builds/JohnLewisPartnership/digital/services/money-web/money-web-ui/node_modules/@JohnLewisPartnership/jlfs-ui-library/dist/styles/jlp-styles.css");
;
import(/* webpackMode: "eager" */ "/builds/JohnLewisPartnership/digital/services/money-web/money-web-ui/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/JohnLewisPartnership/digital/services/money-web/money-web-ui/src/components/NewRelic/NewRelic.tsx");
